export default __webpack_public_path__ + "static/media/DiningArea.ccf350fc.png";